import { makeAutoObservable, reaction } from "mobx"

import { Folder } from "../store/StudentAssignmentsStore"
import type { IStudentAssignmentsStore } from "../store/IStudentAssignmentsStore"
import { StudentAssignmentRowViewModel } from "../viewModels/StudentAssignmentRowViewModel"
import { NavigationAPI } from "../external/NavigationAPI"

export class StudentAssignmentsPresenter {
  rowViewModels: StudentAssignmentRowViewModel[] = []
  isLoading = true
  error: string | null = null

  private disposeReaction?: () => void

  constructor(
    private store: IStudentAssignmentsStore,
    private navigationAPI: NavigationAPI,
  ) {
    makeAutoObservable(this)
    this.setupSubscriptions()
  }

  private setupSubscriptions(): void {
    this.disposeReaction = reaction(
      () => this.store.folders,
      (folders) => this.updateViewModels(folders),
    )
  }

  destroy(): void {
    this.disposeReaction?.()
  }

  private updateViewModels(folders: Folder[]): void {
    this.rowViewModels = folders.map((folder) =>
      StudentAssignmentRowViewModel.fromFolder(
        folder.id,
        folder.title,
        folder.color,
        folder.activeFolder.assignments,
        folder.inactiveFolder.assignments,
        folder.inactiveFolder.roster?.name,
      ),
    )
  }

  async load(): Promise<void> {
    this.isLoading = true
    this.error = null

    try {
      await this.store.getFolders()
      this.isLoading = false
    } catch (err) {
      this.error = "Sorry, there was a problem loading your assignments"
      this.isLoading = false
    }
  }

  handleAssignmentClick(row: StudentAssignmentRowViewModel): void {
    const item = row.assignmentItem
    if (!item || !item.isWork) {
      return
    }

    const work = item.assignment
    this.navigationAPI.goToStudentWork(
      work.id,
      work.assignment.questionIdForIndex(0),
    )
  }
}
